// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"ScrollableTable_tableWrapper__dKYDZ"};